import React from 'react';
import { checkboxExample, textInputExample, radioInputExample } from './codeExamples';
import Checkbox from '../_shared/ui-components/YogaUI/Checkbox';
import FormInput from '../_shared/ui-components/YogaUI/FormInput';
import AloRadioButton from '../_shared/ui-components/YogaUI/AloRadioButton';
import { emailRegex } from '../product/components/VariantSelections/GiftCardRecipientUI';

const FormsAndInputsList = () => {
  return (
    <>
      <div className="items column mb-md">
        <div>
          <p className="editorial-large semibold">Checkbox</p>
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Rest & hover
          </p>
          <div className="yoga-ui-checkbox">
            <input id="yoga-ui-checkbox" type="checkbox" />
            <label htmlFor="yoga-ui-checkbox">Checkbox</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Checked
          </p>
          <div className="yoga-ui-checkbox">
            <input id="yoga-ui-checkbox-checked" type="checkbox" checked />
            <label htmlFor="yoga-ui-checkbox-checked">Checkbox</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Disabled
          </p>
          <div className="yoga-ui-checkbox">
            <input id="yoga-ui-checkbox-disabled" type="checkbox" disabled />
            <label htmlFor="yoga-ui-checkbox-disabled">Checkbox</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            React Example
          </p>
          <Checkbox
            options={{
              id: 'react-checkbox',
              label: 'React checkbox',
              onChange: (event) => {
                console.log(event.target.checked);
              },
            }}
          />
        </div>
      </div>
      <div>
        <pre>{checkboxExample}</pre>
      </div>
      {/* RADIO BUTTON STARTS */}
      <div className="items column mb-md">
        <div>
          <p className="editorial-large semibold">Radio</p>
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Default & Hover
          </p>
          <div className="alo-radio-button">
            <input type="radio" id="first" name="radio-group" value="first" checked={false} />
            <label htmlFor="first">Radio Button</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Selected
          </p>
          <div className="alo-radio-button">
            <input type="radio" id="second" name="radio-group" value="second" checked={true} />
            <label htmlFor="second">Radio Button</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Disabled
          </p>
          <div className="alo-radio-button">
            <input type="radio" id="third" name="radio-group" value="third" checked={false} disabled={true} />
            <label htmlFor="third">Radio Button</label>
          </div>
        </div>
        <div className="section mt-0">
          <p className="body" style={{ width: 100, margin: 0 }}>
            React Example
          </p>
          <AloRadioButton label="Radio Button" value="value" groupName="radio-group" />
        </div>
      </div>
      <div>
        <pre>{radioInputExample}</pre>
      </div>
      {/* RADIO BUTTON END*/}

      <div className="items column mb-md">
        <div>
          <p className="editorial-large semibold">Form Inputs</p>
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Rest & hover without value
          </p>
          <FormInput options={{ id: 'input1', label: 'Label' }} />
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Rest & hover with value
          </p>
          <FormInput options={{ id: 'input2', label: 'Label', defaultValue: 'Hello Yoga UI' }} />
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Disabled
          </p>
          <FormInput options={{ id: 'input3', label: 'Label', disabled: true }} />
        </div>
        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            With caption
          </p>
          <FormInput
            options={{
              id: 'input4',
              label: 'E-mail',
              type: 'email',
              captionText: 'Subscribe and get 10% off',
              errorText: 'Please enter a valid email address',
            }}
          />
        </div>

        <div className="section mt-5">
          <p className="body" style={{ width: 100, margin: 0 }}>
            With caption Filled
          </p>
          <FormInput
            options={{
              id: 'input5',
              label: 'Name',
              defaultValue: 'Name Here',
              captionText: 'Subscribe and get 10% off',
              errorText: 'Please enter a valid email address',
            }}
          />
        </div>
        <div className="section mt-5">
          <p className="body" style={{ width: 100, margin: 0 }}>
            Error
          </p>
          <FormInput
            options={{
              id: 'input6',
              label: 'E-mail',
              type: 'email',
              defaultValue: 'hello$alo.com',
              required: true,
              errorText: 'Please enter a valid email address',
              pattern: emailRegex,
            }}
          />
        </div>

        <div className="section">
          <p className="body" style={{ width: 100, margin: 0 }}>
            React Example
          </p>
          <FormInput
            options={{
              id: 'reactInput',
              label: 'Phone',
              type: 'tel',
              required: true,
              pattern: '[0-9]{3}-[0-9]{3}-[0-9]{4}',
              errorText: 'Please enter a valid phone. Format: 123-456-7890',
            }}
          />
        </div>
      </div>
      <div>
        <pre>{textInputExample}</pre>
      </div>
    </>
  );
};

export default FormsAndInputsList;
